import { RotateCcw, Search, SlidersHorizontal } from 'lucide-react';
import type { FormEvent } from 'react';
import type { TraceFilterForm } from '../types';

interface TraceFiltersBarProps {
  value: TraceFilterForm;
  busy: boolean;
  onChange: (value: TraceFilterForm) => void;
  onSubmit: () => void;
  onReset: () => void;
}

export function TraceFiltersBar({ value, busy, onChange, onSubmit, onReset }: TraceFiltersBarProps) {
  const submit = (event: FormEvent) => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <form className="filters" onSubmit={submit} aria-label="Trace 筛选">
      <div className="filters__heading">
        <SlidersHorizontal size={16} aria-hidden="true" />
        <strong>定位运行</strong>
        <span>跨服务关联检索</span>
      </div>
      <div className="filters__fields">
        <label>
          <span>Room ID</span>
          <input
            value={value.roomId}
            onChange={(event) => onChange({ ...value, roomId: event.target.value })}
            placeholder="room-raven-04"
          />
        </label>
        <label>
          <span>Run ID</span>
          <input
            value={value.runId}
            onChange={(event) => onChange({ ...value, runId: event.target.value })}
            placeholder="run_9c1fd83a"
          />
        </label>
        <label>
          <span>Player ID</span>
          <input
            value={value.playerId}
            onChange={(event) => onChange({ ...value, playerId: event.target.value })}
            placeholder="player_1287"
          />
        </label>
        <label>
          <span>来源</span>
          <select value={value.source} onChange={(event) => onChange({ ...value, source: event.target.value as TraceFilterForm['source'] })}>
            <option value="">全部来源</option>
            <option value="ai-backend">AI Backend</option>
            <option value="game-server">Game Server</option>
            <option value="unity-client">Unity Client</option>
          </select>
        </label>
        <label>
          <span>状态</span>
          <select value={value.status} onChange={(event) => onChange({ ...value, status: event.target.value as TraceFilterForm['status'] })}>
            <option value="">全部状态</option>
            <option value="success">成功</option>
            <option value="running">运行中</option>
            <option value="error">异常</option>
          </select>
        </label>
      </div>
      <div className="filters__actions">
        <button type="button" className="button button--ghost" onClick={onReset} disabled={busy}>
          <RotateCcw size={15} />重置
        </button>
        <button className="button button--primary" disabled={busy}>
          <Search size={15} />{busy ? '检索中' : '检索'}
        </button>
      </div>
    </form>
  );
}
